import { Component, Input, inject } from '@angular/core';

import { DartsMatchType } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore, SitecoreEventDetailsConfig } from '@frontend/sports/common/client-config-data-access';
import {
    AmericanFootballPeriodInfo,
    BasketballPeriodInfo,
    DartsLegsPeriodInfo,
    DartsSetsAndLegsPeriodInfo,
    IceHockeyPeriodInfo,
    SportConstant,
} from '@frontend/sports/common/core/data-access/constants';

import { EpcotModule } from '../../../../common/epcot-config.service';
import { DecreaseTimer } from '../../../../scoreboards/models/scoreboard-timer';
import { IEventTimeViewModel } from '../../../../scoreboards/models/scoreboard.viewmodel';

@Component({
    selector: 'ms-my-bets-scoreboard-time',
    templateUrl: 'my-bets-scoreboard-time.html',
})
export class MyBetsScoreboardTimeComponent {
    sitecore = inject(Sitecore);
    sitecoreEventDetails = inject(SitecoreEventDetailsConfig);

    @Input() vm: IEventTimeViewModel;
    @Input() hideLiveBadge = false;
    module = EpcotModule.MyBetsBetSlip;

    get showEventDate(): boolean {
        if (!this.vm.hasScoreboard || !this.vm.timer) {
            return true;
        }
        if (this.vm.timer && this.vm.timer.countDownTimer) {
            const minutesLeft = this.vm.timer.countDownTimer.getMinutesLeft();

            return minutesLeft >= DecreaseTimer.countDownMinutesBeforeGame;
        }

        return false;
    }

    showTimer(): boolean {
        if (this.vm.sportId === SportConstant.Basketball && this.vm.periodId in BasketballPeriodInfo) {
            return false;
        }
        if (this.vm.sportId === SportConstant.AmericanFootball && this.vm.periodId in AmericanFootballPeriodInfo) {
            return false;
        }
        if (this.vm.sportId === SportConstant.Icehockey && this.vm.periodId in IceHockeyPeriodInfo) {
            return false;
        }

        const sportsWithoutTimer = [SportConstant.Boxing, SportConstant.Cricket];
        if (sportsWithoutTimer.indexOf(this.vm.sportId) >= 0) {
            return false;
        }

        if (
            (this.vm.sportId === SportConstant.Formula1 ||
                this.vm.sportId === SportConstant.Skialpine ||
                this.vm.sportId === SportConstant.Motorbikes ||
                this.vm.sportId === SportConstant.Biathlon ||
                this.vm.sportId === SportConstant.Snooker) &&
            this.vm.isLive
        ) {
            return false;
        }

        return true;
    }

    get showPeriodInfo(): boolean {
        if (
            (this.vm.sportId === SportConstant.Formula1 ||
                this.vm.sportId === SportConstant.Skialpine ||
                this.vm.sportId === SportConstant.Motorbikes ||
                this.vm.sportId === SportConstant.Biathlon) &&
            this.vm.isLive
        ) {
            return false;
        }
        const now = new Date();

        return this.vm.startTime <= now || this.vm.isLive;
    }

    get periodInfo(): string {
        if (this.vm.sportId === SportConstant.Darts) {
            if (this.vm.matchType === DartsMatchType.LegOnly) {
                if (this.vm.periodId === DartsLegsPeriodInfo.Finished) {
                    return this.vm.periodInfo;
                } else if (this.vm.bestOfLegs) {
                    return this.vm.isLive
                        ? `${this.sitecore.globalMessages.BestOf} ${this.vm.bestOfLegs} - ${this.vm.periodInfo}`
                        : this.sitecore.globalMessages.StartsNow;
                } else {
                    return this.vm.isLive
                        ? `${this.sitecore.globalMessages.BestOf} ${this.vm.periodId} - ${this.vm.periodInfo}`
                        : this.sitecore.globalMessages.StartsNow;
                }
            } else if (this.vm.matchType === DartsMatchType.SetsAndLegs) {
                if (this.vm.periodId === DartsSetsAndLegsPeriodInfo.Finished) {
                    return this.vm.periodInfo;
                } else if (this.vm.bestOfSets) {
                    return this.vm.isLive
                        ? `${this.sitecore.globalMessages.BestOf} ${this.vm.bestOfSets} - ${this.vm.periodInfo}`
                        : this.sitecore.globalMessages.StartsNow;
                } else {
                    return this.vm.isLive
                        ? `${this.sitecore.globalMessages.BestOf} ${this.vm.periodId} - ${this.vm.periodInfo}`
                        : this.sitecore.globalMessages.StartsNow;
                }
            } else {
                return this.vm.isLive ? this.vm.periodInfo : this.sitecore.globalMessages.StartsNow;
            }
        } else if (this.vm.sportId === SportConstant.Snooker) {
            return this.vm.isLive ? this.getBestOf() : this.sitecore.globalMessages.StartsNow;
        } else {
            return this.vm.isLive ? this.vm.periodInfo : this.sitecore.globalMessages.StartsNow;
        }
    }

    getBestOf(): string {
        return this.vm.bestOf ? `${this.sitecore.globalMessages.BestOf} ${this.vm.bestOf}` : '';
    }

    get liveText(): string {
        return this.sitecore.event.Live;
    }
}
